import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {NotificationActions} from "../actions";
import {catchError, map, mergeMap} from "rxjs";
import {ApiError, NotificationsService} from "@esa/api";
import {ApiErrorHandlerService} from "../../services";

@Injectable()
export class NotificationsEffects {

  getNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.getNotifications),
      mergeMap(({}) => this._notificationsService.getApiNotification().pipe(
        map(notifications => NotificationActions.getNotificationsSuccess({ notifications })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, NotificationActions.getNotificationsError());
        })
      ))
    );
  });

  createNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.createNotification),
      mergeMap(({ notification }) => this._notificationsService.postApiNotification(notification).pipe(
        map(response => {
          return NotificationActions.createNotificationSuccess();
        }),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, NotificationActions.createNotificationError());
        })
      ))
    );
  });

  updateNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.updateNotification),
      mergeMap(({ notification }) => this._notificationsService.putApiNotification(notification).pipe(
        map(response => {
          return NotificationActions.updateNotificationSuccess();
        }),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, NotificationActions.updateNotificationError());
        })
      ))
    );
  });

  loadNotificationsOnUpdate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.updateNotificationSuccess),
      map(() => NotificationActions.getNotifications())
    );
  });

  loadNotificationsOnCreate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.createNotificationSuccess),
      map(() => NotificationActions.getNotifications())
    );
  });

  constructor(
    private actions$: Actions,
    private _notificationsService: NotificationsService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}
}
